import { ErrorBaseData } from '.'

export const cfmErrors: Record<string, ErrorBaseData> = {
  CrmCpfMismatchException: {
    message: 'CRM e CPF não batem',
    description: 'Verifique as informações e tente novamente',
  },
  InvalidCrmException: {
    message: 'CRM inválido',
    description: 'Verifique as informações e tente novamente',
  },
}
